import "./PlayerCardStyles.css"
import React from 'react'
import { NavLink } from "react-router-dom"


const PlayerCard = () => {
  return (
    <div classname="player-container">
        <h1 className="player-heading">The Blues 💙</h1>
        <div className="player-container">
            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p61366.png" alt="player"/>
                <h2 className="player-name">Kevin De Bruyne</h2>
                <div className="player-details">
                    <p>
                   Known for his incredible range of passing, De Bruyne's ability to deliver accurate long balls, through balls, and
                crosses has been a constant threat to opposition defenses. He possesses exceptional vision, effortlessly spotting and 
                executing key passes that often lead to goals. 
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Kevin_De_Bruyne" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/kevin-de-bruyne/profil/spieler/88755" className="btn2">Market</NavLink>
                </div>
            </div> 
            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p223094.png" alt="player"/>
                <h2 className="player-name">Erling Haaland</h2>
                <div className="player-details">
                    <p>
                    A natural born goalscorer, Haaland has been exceptionally well for City in the season 2022'23. 
                    He broke the PL record for most goals in debut season.Overall He's a talent and physical beast
                    of a poacher every team looks for.His purchase has made City an altogether better team.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Erling_Haaland" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/erling-haaland/leistungsdaten/spieler/418560" className="btn2">Market</NavLink>
                </div>
            </div> 

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p165809.png" alt="player"/>
                <h2 className="player-name">Bernado Silva</h2>
                <div className="player-details">
                    <p>
                    Portuguese attacking midfielder known for his agility, creativity, and technical prowess. 
                    His close ball control, intelligent movement, and ability to unlock defenses have made him a crucial playmaker for Manchester City.
                    He has incredible first touch and can dribble past players with ease.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Bernardo_Silva" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/bernardo-silva/profil/spieler/241641" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p59859.png" alt="player"/>
                <h2 className="player-name">Ilkay Gündogan</h2>
                <div className="player-details">
                    <p>
                    German midfielder renowned for his versatility and intelligent positioning. With excellent passing range, goal-scoring ability, and tactical awareness,
                    Gundogan has been instrumental in Manchester City's success. His composure under pressure and ability to control the midfield make him an indispensable asset.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/%C4%B0lkay_G%C3%BCndo%C4%9Fan" className="btn">Wikipedia</NavLink>
                    <NavLink to="]https://www.transfermarkt.co.in/ilkay-gundogan/profil/spieler/53622" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p103025.png" alt="player"/>
                <h2 className="player-name">Riyad Mahrez</h2>
                <div className="player-details">
                    <p>
                     Algerian winger, is renowned for his exceptional dribbling skills, pace, and precise left foot.
                     His ability to cut inside from the right flank and deliver accurate shots or crosses has made him a vital asset for Manchester City.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Riyad_Mahrez" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/riyad-mahrez/profil/spieler/171424" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p209244.png" alt="player"/>
                <h2 className="player-name">Phil Foden</h2>
                <div className="player-details">
                    <p>
                    He's Known for his close ball control, vision, and intelligent movement,Foden possesses the ability to dictate
                    the tempo of the game and create scoring opportunities.His versatility and creativity have earned him a key role for both Manchester City.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Phil_Foden" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/phil-foden/profil/spieler/406635" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p114283.png" alt="player"/>
                <h2 className="player-name">Jack Grealish</h2>
                <div className="player-details">
                    <p>
                    An English attacking midfielder, is known for his flair, technical ability,
                    and exceptional dribbling skills. With his low center of gravity and close control, Grealish can weave through defenses effortlessly.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Jack_Grealish" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/jack-grealish/profil/spieler/203460" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p461358.png" alt="player"/>
                <h2 className="player-name">Julián Álvarez</h2>
                <div className="player-details">
                    <p>
                    A world-cup winning Argentine.He has emerged as a promising talent in recent years. Best Known for his blistering pace, technical skills, and goal-scoring ability, 
                    He is deemed to be the successor of the City Legend "Sergio Aguero".
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Juli%C3%A1n_%C3%81lvarez_(footballer)" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/julian-alvarez/profil/spieler/576024" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p220566.png" alt="player"/>
                <h2 className="player-name">Rodri</h2>
                <div className="player-details">
                    <p>
                    He's a key player for Manchester City and the Spanish national team.
                    Known for his exceptional passing ability and composure on the ball, he plays a crucial role in controlling the tempo of the game and initiating attacks.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Rodri_(footballer,_born_1996)" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/rodri/profil/spieler/357565" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p155405.png" alt="player"/>
                <h2 className="player-name">Kalvin Philips</h2>
                <div className="player-details">
                    <p>
                    With his tireless work rate and strong tackling ability, he provides excellent defensive cover while also showcasing his vision and passing skills in the midfield.
                    He's proved himself at England and Leeds United. He's a great asset for the future.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Kalvin_Phillips" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/kalvin-phillips/profil/spieler/351749" className="btn2">Market</NavLink>
                </div>
            </div>


            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p211975.png" alt="player"/>
                <h2 className="player-name">Manuel Akanji</h2>
                <div className="player-details">
                    <p>
                    He's  a Swiss known for his strong aerial presence and intelligent positioning, he excels in both one-on-one duels and reading the game.
                    He's been a gamechanger this season for the team as he controlled the right wing like no one ever before.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Manuel_Akanji" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/manuel-akanji/profil/spieler/284730" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p126184.png" alt="player"/>
                <h2 className="player-name">Nathan Ake</h2>
                <div className="player-details">
                    <p>
                    A Dutch center-back, brings versatility and composure to the defense. With his excellent ball-playing abilities
                    and ability to initiate attacks from the back, he adds an extra dimension to his team's build-up play. He's been extremely well on the left 
                    wing this season.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Nathan_Ak%C3%A9" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/nathan-ake/profil/spieler/177476" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p171314.png" alt="player"/>
                <h2 className="player-name">Ruben Dias</h2>
                <div className="player-details">
                    <p>
                    Portuguese defender who's quite literally the defensive leader.
                    His exceptional reading of the game, physicality, and commanding presence make him a formidable force at the heart of the defense.
                    He is the single-piece that holds the entire city defense line and it's not wrong to say he does it well.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/R%C3%BAben_Dias" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/ruben-dias/profil/spieler/258004" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p97299.png" alt="player"/>
                <h2 className="player-name">John Stones</h2>
                <div className="player-details">
                    <p>
                    He's the reason of all the success city is getting this season. He has worked as a transitional midfielder cum defender and 
                    has shown incredile work rate. He has insane physicality,tackling skills and also has a keen eye for passing. He has always been phenomenal for city but this season
                    was unarguably his best ever. 
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/John_Stones" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/john-stones/profil/spieler/186590" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p146941.png" alt="player"/>
                <h2 className="player-name">Aymeric Laporte</h2>
                <div className="player-details">
                    <p>
                    A Spaniard who's known for his composed style of play, excellent positioning, and ability to read the game, Laporte consistently
                    demonstrates his defensive prowess. With his calmness on the ball and precise passing, he also contributes to City's fluid attacking play.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Aymeric_Laporte" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/aymeric-laporte/profil/spieler/176553" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p58621.png" alt="player"/>
                <h2 className="player-name">Kyle Walker</h2>
                <div className="player-details">
                    <p>
                    An English right-back, possesses lightning-fast pace and incredible defensive instincts.
                    His ability to track back and make crucial interventions, along with his overlapping runs in attack, makes him a vital asset.
                    He's been phenomenal this season stopping world-class LWs.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Kyle_Walker" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/kyle-walker/profil/spieler/95424" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p121160.png" alt="player"/>
                <h2 className="player-name">Ederson</h2>
                <div className="player-details">
                    <p>
                    He is renowned for his exceptional shot stopping ability and ball control. Ederson's ability to initiate attacks with his
                    pinpoint long passes and precise short distribution adds an extra dimension to City's playing style. He's an exceptional keeper.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Ederson_(footballer,_born_1993)" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/ederson/profil/spieler/238223" className="btn2">Market</NavLink>
                </div>
            </div>

            <div className="player-card">
                <img src="https://resources.premierleague.com/premierleague/photos/players/250x250/p88248.png" alt="player"/>
                <h2 className="player-name">Stefan Ortega</h2>
                <div className="player-details">
                    <p>
                    He's known for his agility, shot stopping abilities, and commanding presence in the box. He came in as a free transfer this season.
                    He conceded 0 goals in open play during the entire campaign of FA Cup 2023.
                    </p>
                </div>
                <div className="player-button">
                    <NavLink to="https://en.wikipedia.org/wiki/Stefan_Ortega" className="btn">Wikipedia</NavLink>
                    <NavLink to="https://www.transfermarkt.co.in/stefan-ortega/profil/spieler/85941" className="btn2">Market</NavLink>
                </div>
            </div>
            
        </div>
    </div>
  )
}

export default PlayerCard
